module.exports = __webpack_public_path__ + "assets/img/16_1740_big.667f42cd.jpg";